/*
 * @Author: Gary
 * @Date: 2017-11-07 09:29:09
 * @Last Modified by: yuxiaojing
 * @Last Modified time: 2018-02-22 14:28:55
 * 过滤器
 */

// 日期时间
let date = (date, index1, index2) => {
  // 1970-01-01 08:00:00
  let end = index1 || 10
  let start = index2 || 0
  if (date) {
    return date.slice(start, end)
  } else {
    return ''
  }
}

// 货币
let currency = (money) => {
  let res = +money
  if (res.isNaN()) {
    return Math.floor(res * 100) / 100
  } else {
    return money
  }
}

// 货币格式化，每隔三位加一个逗号
let money = (value) => {
  if (!value) return
  value = value.toString()
  return value.replace(/^(-?)(\d+)((\.\d+)?)$/, (s, s1, s2, s3) => {
    let rex = /\d{1,3}(?=(\d{3})+$)/g
    let result = s1 + s2.replace(rex, '$&,') + s3
    return result
  })
}

// 人数
let count = (num) => {
  num = +num
  if (num > 10000) {
    return (num / 10000).toFixed(1) + '万'
  } else {
    return num
  }
}

export {
  date, currency, count, money
}



// WEBPACK FOOTER //
// ./src/utils/filter.js